import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Arrow from 'ui/components/generic/Arrow'

const ArrowWrapper = styled.span`
  transition: all 400ms;
`

const Wrapper = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  &:hover ${ArrowWrapper} {
    transform: translateX(10px);
    opacity: 0.3;
  }
`

const Text = styled.span`
  display: inline-block;
  margin-right: 20px;
`

class ArrowLink extends Component {
  render() {
    const { children, ...rest } = this.props
    return (
      <Wrapper {...rest}>
        <Text>
          {children}
        </Text>
        <ArrowWrapper>
          <Arrow direction="right" />
        </ArrowWrapper>
      </Wrapper>
    )
  }
}

export default ArrowLink


// WEBPACK FOOTER //
// ./src/ui/components/generic/ArrowLink.js